import React from 'react';
import { MP_SURF } from '../constants/surfaces.js';

export default function Fsection({ label, children, last }) {
  return (
    <div style={{ marginBottom: last ? 0 : 14, paddingBottom: last ? 0 : 14, borderBottom: last ? 'none' : `1px solid ${MP_SURF.divider}` }}>
      <div style={{ fontSize: '0.68rem', fontWeight: 700, color: MP_SURF.labelMuted, textTransform: 'uppercase', letterSpacing: '0.09em', marginBottom: 8 }}>{label}</div>
      {children}
    </div>
  );
}
